import React from "react";
import { useSelector } from "react-redux";
import { profileSlice } from "redux/features/profile";
import { Message } from "react-bulma-components";

export function ResearchSummary() {
  const { data } = useSelector(profileSlice.selector);
  if (!data.require_research_reports) return null;
  return (
    <Message>
      <Message.Header>Research & Collaborations</Message.Header>
      <Message.Body>
        <div className="block">
          <b>Coming soon:</b> A portal where you can tell us about{" "}
          <b>research outputs</b> (publications, preprints, conference
          presentations, etc) and <b>collaborations</b> that have been
          facilitated by your participation in Fields Institute programs and
          events.
        </div>
      </Message.Body>
    </Message>
  );
}
